import { h } from 'preact'
import styles from './index.module.css'

export function Asterism() {
  return (
    <div className={styles.asterism} aria-hidden>
      &#8258;
    </div>
  )
}
